import * as React from "react";

export default function AdminShieldFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M12 2.5c.276 0 .548.043.809.125l7 2.188A1.5 1.5 0 0 1 21 6.25v5.25c0 3.76-2.334 7.125-5.846 8.67l-2.269.999a1.5 1.5 0 0 1-1.27 0l-2.269-.999C5.334 18.625 3 15.26 3 11.5V6.25a1.5 1.5 0 0 1 1.191-1.437l7-2.188A1.5 1.5 0 0 1 12 2.5Zm3.78 6.72a1 1 0 0 0-1.56-1.248l-3.47 4.338-1.47-1.47a1 1 0 0 0-1.414 1.415l2.25 2.25a1 1 0 0 0 1.487-.083l4.176-5.22Z" />
    </svg>
  );
}

